module.exports = __webpack_public_path__ + "img/icon-close-dark.d34f84f4.svg";